function initAccordionReferences() {
  let items = document.querySelectorAll('.accordion.references');
  if (items.length < 0) {return;}

  items.forEach((item, i) => {
    item.classList.add('collapsed');
    item.children[0].addEventListener("click", function(e) {
      e.target.parentNode.classList.toggle('collapsed');
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initAccordionReferences();
});
